<template>
  <FusionBaseDialog
    :open="open"
    :title="$t('alertHistory.export.title')"
    :persistentOverlay="true"
    icon="mdi-file-download"
    @close="close"
    padded
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        @click.stop="open = true"
        variant="text"
        prepend-icon="mdi-file-download"
      >
        {{ $t('buttons.export') }}
      </v-btn>
    </template>
    <v-card v-if="downloading" class="padding-top-16" flat>
      <span class="message">
        {{ $t('alertHistory.export.dialog.message') }}
      </span>
    </v-card>
    <v-card v-else class="pa-4" flat>
      <div class="form-section-header">
        {{ $t('alertHistory.export.dialog.dateRange') }}
      </div>
      <v-row justify="center">
        <DatePickerMenu
          v-model="dateStart"
          :label="$t('alertHistory.export.dialog.from')"
          :min="getMinDate()"
          :max="getMaxDate()"
        />
      </v-row>
      <v-row justify="center">
        <DatePickerMenu
          v-model="dateEnd"
          :label="$t('alertHistory.export.dialog.to')"
          :min="getMinDate()"
          :max="getMaxDate()"
        />
      </v-row>
    </v-card>
    <template v-slot:actions>
      <template v-if="!downloading">
        <v-btn @click="close" variant="outlined" class="text-black">
          {{ $t('buttons.close') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="exportNotifications" class="bg-primary text-white" variant="text">
          {{ $t('buttons.export') }}
        </v-btn>
      </template>
      <template v-if="downloading">
        <v-spacer></v-spacer>
        <v-btn v-if="downloading" @click="close" class="bg-primary text-white" variant="text">
          {{ $t('buttons.done') }}
        </v-btn>
      </template>
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { getTodayDateObject, formatDate } from '../../services/data-export'
import DatePickerMenu from '../common/DatePickerMenu.vue'

const ONE_DAY_MS = 1000 * 60 * 60 * 24
const THIRTY_DAYS_MS = ONE_DAY_MS * 30

export default defineComponent({
  name: 'ExportNotifications',
  components: { DatePickerMenu },
  emits: ['close'],
  data() {
    return {
      open: false,
      dateStart: null as string | null,
      dateEnd: null as string | null,
      downloading: false
    }
  },
  watch: {
    open() {
      this.init()
    },
    dateStart() {
      if (new Date(this.dateStart) > new Date(this.dateEnd)) {
        this.dateEnd = this.dateStart
      }
    },
    dateEnd() {
      if (new Date(this.dateStart) > new Date(this.dateEnd)) {
        this.dateStart = this.dateEnd
      }
    }
  },
  methods: {
    getDateToday() {
      return getTodayDateObject()
    },
    init() {
      this.dateStart = formatDate(this.getDateToday().getTime() - ONE_DAY_MS)
      this.dateEnd = formatDate(this.getDateToday().getTime())
    },
    getMinDate() {
      return formatDate(this.getDateToday().getTime() - THIRTY_DAYS_MS + ONE_DAY_MS)
    },
    getMaxDate() {
      return formatDate(this.getDateToday())
    },
    close() {
      this.$emit('close')
      this.open = false
      setTimeout(() => {
        this.downloading = false
      }, 50)
    },
    async exportNotifications() {
      this.downloading = true

      let RFC3339End: string

      if (new Date(this.dateEnd).getUTCDate() == new Date().getUTCDate()) {
        RFC3339End = new Date().toISOString()
      } else {
        RFC3339End = new Date(this.dateEnd).toISOString()
      }
      const RFC3339Start = new Date(this.dateStart).toISOString()

      await this.$api.getNotificationsCSV(RFC3339Start, RFC3339End)
    }
  }
})
</script>

<style lang="scss" scoped>
.v-dialog {
  .v-card {
    min-height: 350px;
    .v-input {
      padding-top: 24px;
    }
    .form-section-header {
      font-weight: 300;
      font-size: 18px;
      margin-left: -12px;
      margin-bottom: 24px;
      opacity: 0.56;
    }
    .message {
      color: rgba(0, 0, 0, 0.56);
    }
  }
  .v-card__subtitle {
    min-height: 30px;
    padding: 16px 12px 8px 12px;
  }
  .v-card__title {
    font-weight: 300;
    padding: 0 0 16px 0;
  }
  .v-btn {
    min-width: 120px !important;
    @media (min-width: 496px) {
      min-width: 160px !important;
    }
  }
}

.op-76 {
  opacity: 0.76;
}
</style>
